import { useI18n, useL } from "../i18n";
import { Compass, Sparkles, Map, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t, lang } = useI18n();
  const L = useL();
  return (
    <footer className="mt-20 bg-[#1C1917] text-[#FAF7F2]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-[#C85A32] grid place-items-center font-display">ر</div>
            <div className="font-display text-xl">{t("brand")}</div>
          </div>
          <p className="mt-3 text-sm opacity-80 max-w-md leading-relaxed">
            {L({
              ar: "رحّال دليل ذكي يجمع بين أجمل الوجهات في الشرق الأوسط، أسعار حقيقية، ومساعد سفر بالذكاء الاصطناعي — كل ما يلزم لرحلة لا تنسى.",
              en: "Rahhal is a smart guide combining the most beautiful Middle East destinations, real prices, and an AI travel concierge — everything you need for an unforgettable trip.",
              fr: "Rahhal est un guide intelligent réunissant les plus belles destinations du Moyen-Orient, des prix réels et un concierge de voyage IA — tout pour un séjour inoubliable."
            })}
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-widest opacity-70 mb-3">
            {L({ ar: "استكشف", en: "Explore", fr: "Explorer" })}
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#C85A32] inline-flex items-center gap-2"><Compass className="h-3.5 w-3.5" /> {t("nav_explore")}</Link></li>
            <li><Link to="/prices" className="hover:text-[#C85A32] inline-flex items-center gap-2"><DollarSign className="h-3.5 w-3.5" /> {t("nav_prices")}</Link></li>
            <li><Link to="/planner" className="hover:text-[#C85A32] inline-flex items-center gap-2"><Map className="h-3.5 w-3.5" /> {t("nav_planner")}</Link></li>
            <li><Link to="/assistant" className="hover:text-[#C85A32] inline-flex items-center gap-2"><Sparkles className="h-3.5 w-3.5" /> {t("nav_assistant")}</Link></li>
            <li><Link to="/blog" className="hover:text-[#C85A32] inline-flex items-center gap-2">📝 {L({ ar: "المدوّنة", en: "Blog", fr: "Blog" })}</Link></li>
            <li><Link to="/promote" className="hover:text-[#C85A32] inline-flex items-center gap-2 opacity-70">📢 {L({ ar: "دليل الترويج", en: "Marketing hub", fr: "Marketing" })}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-widest opacity-70 mb-3">
            {L({ ar: "قريباً", en: "Coming soon", fr: "Bientôt" })}
          </div>
          <ul className="space-y-2 text-sm opacity-80">
            <li>iOS App Store</li>
            <li>Google Play</li>
            <li>{L({ ar: "حجوزات مباشرة", en: "Direct bookings", fr: "Réservations directes" })}</li>
          </ul>
          <div className="mt-5 text-[11px] uppercase tracking-widest opacity-70 mb-2">
            {L({ ar: "المزيد", en: "More", fr: "Plus" })}
          </div>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/about" className="hover:text-[#C85A32]">{L({ ar: "من نحن", en: "About", fr: "À propos" })}</Link></li>
            <li><Link to="/contact" className="hover:text-[#C85A32]">{L({ ar: "اتصل بنا", en: "Contact", fr: "Contact" })}</Link></li>
            <li><Link to="/privacy" className="hover:text-[#C85A32]">{L({ ar: "سياسة الخصوصية", en: "Privacy", fr: "Confidentialité" })}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-4 text-xs opacity-70">
          {t("footer_note")}
        </div>
      </div>
    </footer>
  );
}
